enum ToUsersEnum {
	All = 0,
	FreeTariff = 1
}
export default ToUsersEnum
